import { render } from "./editDocumentDialog.vue?vue&type=template&id=9179669e"
import script from "./editDocumentDialog.vue?vue&type=script&lang=js"
export * from "./editDocumentDialog.vue?vue&type=script&lang=js"

import "./editDocumentDialog.vue?vue&type=style&index=0&id=9179669e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__